import React, {ReactNode, ReactNodeArray} from 'react';
import EpiComponent from '@episerver/spa-core/EpiComponent';
import GenericGuideTitleBlockData from '../../../Models/Content/GenericGuideTitleBlockData';
import GenericGuideTitle from './GenericGuideTitleBlock';

export default class GenericGuideTitleBlock extends EpiComponent<GenericGuideTitleBlockData> {
  public render(): ReactNode | ReactNodeArray | null {
    let cssClasses: Array<string> = ['generic-guide-title-block'];

    return (
      <div className={cssClasses.join(" ")}>
            <GenericGuideTitle iContent={this.props.data} context={this.getContext()} />
      </div>
    )
  }
}

